import { I18nAndL10n } from '@modules/i18n_and_l10n/mod';
import { rem } from '@visiba/std';
import styled from 'styled-components';

export type AvailableCountryAssets =
	| 'ad'
	| 'ae'
	| 'af'
	| 'ag'
	| 'al'
	| 'am'
	| 'ao'
	| 'ar'
	| 'at'
	| 'au'
	| 'az'
	| 'ba'
	| 'bb'
	| 'bd'
	| 'be'
	| 'bf'
	| 'bg'
	| 'bh'
	| 'bi'
	| 'bj'
	| 'bn'
	| 'bo'
	| 'br'
	| 'bs'
	| 'bt'
	| 'bw'
	| 'by'
	| 'bz'
	| 'ca'
	| 'cd'
	| 'cf'
	| 'cg'
	| 'ch'
	| 'ci'
	| 'ck'
	| 'cl'
	| 'cm'
	| 'cn'
	| 'co'
	| 'cr'
	| 'cu'
	| 'cv'
	| 'cy'
	| 'cz'
	| 'de'
	| 'dj'
	| 'dk'
	| 'dm'
	| 'do'
	| 'dz'
	| 'ec'
	| 'ee'
	| 'eg'
	| 'er'
	| 'es'
	| 'et'
	| 'fi'
	| 'fj'
	| 'fm'
	| 'fr'
	| 'ga'
	| 'gb'
	| 'gd'
	| 'ge'
	| 'gh'
	| 'gm'
	| 'gn'
	| 'gq'
	| 'gr'
	| 'gt'
	| 'gw'
	| 'gy'
	| 'hk'
	| 'hn'
	| 'hr'
	| 'ht'
	| 'hu'
	| 'id'
	| 'ie'
	| 'il'
	| 'in'
	| 'iq'
	| 'ir'
	| 'is'
	| 'it'
	| 'jm'
	| 'jo'
	| 'jp'
	| 'ke'
	| 'kg'
	| 'kh'
	| 'ki'
	| 'km'
	| 'kn'
	| 'kp'
	| 'kr'
	| 'kw'
	| 'kz'
	| 'la'
	| 'lb'
	| 'lc'
	| 'li'
	| 'lk'
	| 'lr'
	| 'ls'
	| 'lt'
	| 'lu'
	| 'lv'
	| 'ly'
	| 'ma'
	| 'mc'
	| 'md'
	| 'me'
	| 'mg'
	| 'mh'
	| 'mk'
	| 'ml'
	| 'mm'
	| 'mn'
	| 'mr'
	| 'mt'
	| 'mu'
	| 'mv'
	| 'mw'
	| 'mx'
	| 'my'
	| 'mz'
	| 'na'
	| 'ne'
	| 'ng'
	| 'ni'
	| 'nl'
	| 'no'
	| 'np'
	| 'nr'
	| 'nu'
	| 'nz'
	| 'om'
	| 'pa'
	| 'pe'
	| 'pg'
	| 'ph'
	| 'pk'
	| 'pl'
	| 'pt'
	| 'pw'
	| 'py'
	| 'qa'
	| 'ro'
	| 'rs'
	| 'ru'
	| 'rw'
	| 'sa'
	| 'sb'
	| 'sc'
	| 'sd'
	| 'se'
	| 'sg'
	| 'si'
	| 'sk'
	| 'sl'
	| 'sm'
	| 'sn'
	| 'so'
	| 'sr'
	| 'ss'
	| 'st'
	| 'sv'
	| 'sy'
	| 'sz'
	| 'td'
	| 'tg'
	| 'th'
	| 'tj'
	| 'tl'
	| 'tm'
	| 'tn'
	| 'to'
	| 'tr'
	| 'tt'
	| 'tv'
	| 'tw'
	| 'tz'
	| 'ua'
	| 'ug'
	| 'us'
	| 'uy'
	| 'uz'
	| 'va'
	| 'vc'
	| 've'
	| 'vg'
	| 'vn'
	| 'ws'
	| 'xk'
	| 'ye'
	| 'za'
	| 'zm'
	| 'zw';

interface Props {
	code: AvailableCountryAssets | '';
}

const elements = {
	wrapper: styled.div`
		width: ${rem(32)};
		height: ${rem(20)};
		background: rgba(57, 57, 57, 0.2);
		border-radius: ${rem(4)};
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
	`,
	img: styled.div<{ url: string }>`
		width: 100%;
		height: 100%;
		background-size: cover;
		background-position: center;
		background-image: url(${({ url }) => url});
	`,
};

export function CountryFlag(props: Props): JSX.Element {
	const url = `/assets/flags/flag_${getSvgPath(props.code)}.svg`;

	return (
		<elements.wrapper>{props.code !== '' ? <elements.img url={(window.__TEMP__ ? '/PublicV3' : '') + url} /> : null}</elements.wrapper>
	);
}

function getSvgPath(code: string): AvailableCountryAssets | '' {
	let knownVisibaLocal: I18nAndL10n.AvailableVisibaLocales;
	try {
		knownVisibaLocal = I18nAndL10n.convertExternalLocaleToAvailableLocale(code);
	} catch {
		return '';
	}

	// TODO: DEV-10574 This should not be hardcoded here.
	let country: AvailableCountryAssets;
	switch (knownVisibaLocal) {
		case 'sv':
			country = 'se';
			break;
		case 'ar':
			country = 'ae';
			break;
		case 'da':
			country = 'dk';
			break;
		case 'de':
			country = 'de';
			break;
		case 'en-gb':
			country = 'gb';
			break;
		case 'fa':
			country = 'ir';
			break;
		case 'fi':
			country = 'fi';
			break;
		case 'hr':
			country = 'hr';
			break;
		case 'nb':
			country = 'no';
			break;
		case 'pt-br':
			country = 'br';
			break;
		case 'nl':
			country = 'nl';
			break;
		default:
			return '';
	}

	return country;
}
